import React, {useEffect} from "react";
import {useParams} from "react-router";


const Cv = ()=> {

  const params=useParams();

  const href= window.location.href;
  const hToken=localStorage.getItem('hToken');
  const headers=hToken &&  new Headers();

  const ar = Array(10).fill(1);
  useEffect(()=>{



  },[])
  return (
      <div className='d-flex flex-col justify-between'>

        <section className="artdeco-card pb3">
         


          <div className="display-flex justify-flex-start align-items-center pt3 ph3">

            <div className="flex-grow-1 display-flex justify-space-between">
              <h1 className="my-4 display-4">
                Experience
              </h1>

            </div>
          </div>


          <div className="pvs-list__container">
            <div className="scaffold-finite-scroll
    scaffold-finite-scroll--infinite
    ">
             

              <div className="scaffold-finite-scroll__content">

                <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim " tabIndex="-1">
                  <li className="pvs-list__paged-list-item artdeco-list__item pvs-list__item--line-separated pvs-list__item--one-column"
                      id="profilePagedListComponent-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-EXPERIENCE-VIEW-DETAILS-profile-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-NONE-en-US-0">
                    <div>


                     
                      <div className="HeuPqLcJMVEBjxzlrwqBUcusWgcyzaCs
        KgUCFrDhnFecSkQSZkbikfdnXTGbJqxo UmammeebeSSIxbEFumhBTlnCJKUCqsgeIcMKZc
        
        
        
        " data-view-name="profile-component-entity">
                        <div>

                          <a className="optional-action-target-wrapper 
            
            pvs-entity__image-container--outline-offset
            display-flex" target="_self" href="https://www.linkedin.com/company/102893052/">

                            <div className="ivm-image-view-model  pvs-entity__image ">

                              <div className="ivm-view-attr__img-wrapper
        
        ">
                               
                                <img width="48"
                                             src="https://media.licdn.com/dms/image/v2/D4D0BAQE3gpyfYxcPzg/company-logo_100_100/company-logo_100_100/0/1715172705921/the_times_of_central_asia_logo?e=1778112000&amp;v=beta&amp;t=R-OHPWbV4Hpk4t_gyqmSpeeZTVdFwbZFgctsxkFcTXQ"
                                             loading="lazy" height="48" alt="The Times of Central Asia logo"
                                             id="ember520"
                                             className="ivm-view-attr__img--centered EntityPhoto-square-3   evi-image lazy-image ember-view"/>
                              </div>

                            </div>

                          </a>

                        </div>

                        <div className="display-flex flex-column align-self-center flex-grow-1">
                          <div className="display-flex flex-row justify-space-between">

                            <a className="optional-action-target-wrapper 
              display-flex flex-column full-width" target="_self"
                               href="https://www.linkedin.com/in/facereplays/add-edit/POSITION/?profileFormEntryPoint=PROFILE_SECTION&amp;entityUrn=urn%3Ali%3Afsd_profilePosition%3A%28ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE%2C2657824839%29&amp;trackingId=jMG2%2FMQcSFaaoNPHEfhZng%3D%3D&amp;desktopBackground=PROFILE_DETAIL_SCREEN">
                              <div className="display-flex flex-wrap align-items-center full-height">

                                <div className="display-flex ">

                                  <div className="
          display-flex full-width">

                                    <div className="display-flex align-items-center
              mr1 hoverable-link-text t-bold">
                                      <span aria-hidden="true">Freelance Illustrator</span><span
                                        className="visually-hidden">Freelance Illustrator</span>
                                    </div>
                                   
                                  </div>

                                </div>

                                           </div>
                              <span className="t-14 t-normal">
                  <span aria-hidden="true">The Times of Central Asia · Freelance</span><span
                                  className="visually-hidden">The Times of Central Asia · Freelance</span>
                </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span className="pvs-entity__caption-wrapper"
                      aria-hidden="true">Apr 2024 - Present · 2 yrs 1 mo</span><span
                                  className="visually-hidden">Apr 2024 to Present · 2 yrs 1 mo</span>
              </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span aria-hidden="true">Remote</span><span
                                  className="visually-hidden">Remote</span>
              </span>
                            </a>

                          </div>

                          <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY pvs-entity__sub-components">
                           
                            <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true">The Times of Central Asia<br/>Freelance Illustrator &amp; Web Developer<br/>April 2024 - Present<br/>Create compelling editorial illustrations for news articles and special reports, enhancing reader engagement and clarifying complex topics through visual storytelling.<br/>Developed a custom, browser-based web application to streamline the editorial workflow for image preparation. The tool enables editors to efficiently enhance, scale, and apply consistent branding (overlays, watermarks) to all visual assets before publication.</span><span
                                              className="visually-hidden">The Times of Central Asia
Freelance Illustrator &amp; Web Developer
April 2024 - Present
Create compelling editorial illustrations for news articles and special reports, enhancing reader engagement and clarifying complex topics through visual storytelling.
Developed a custom, browser-based web application to streamline the editorial workflow for image preparation. The tool enables editors to efficiently enhance, scale, and apply consistent branding (overlays, watermarks) to all visual assets before publication.</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true"><strong>Skills:</strong><span
                                                className="white-space-pre"> </span>political illustration</span><span
                                              className="visually-hidden"><strong>Skills:</strong><span
                                              className="white-space-pre"> </span>political illustration</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                            </ul>
                               </div>

                        </div>
                       

                      </div>


                    </div>

                  </li>
                  <li className="pvs-list__paged-list-item artdeco-list__item pvs-list__item--line-separated pvs-list__item--one-column"
                      id="profilePagedListComponent-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-EXPERIENCE-VIEW-DETAILS-profile-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-NONE-en-US-1">
                    <div>


                     
                      <div className="HeuPqLcJMVEBjxzlrwqBUcusWgcyzaCs
        KgUCFrDhnFecSkQSZkbikfdnXTGbJqxo UmammeebeSSIxbEFumhBTlnCJKUCqsgeIcMKZc
        
        
        
        " data-view-name="profile-component-entity">
                        <div>

                          <a className="optional-action-target-wrapper 
            
            pvs-entity__image-container--outline-offset
            display-flex" target="_self" href="https://www.linkedin.com/company/92569403/">

                            <div className="ivm-image-view-model  pvs-entity__image ">

                              <div className="ivm-view-attr__img-wrapper
        
        ">
                               
                                <img width="48"
                                             src="https://media.licdn.com/dms/image/v2/D4D0BAQErNq_C33wjvA/company-logo_100_100/company-logo_100_100/0/1680425739481?e=1778112000&amp;v=beta&amp;t=dQktxS1DLodcF67ltLJaSeRZedv4zNh0U6WIo6Pgebg"
                                             loading="lazy" height="48" alt="Esketchos logo" id="ember527"
                                             className="ivm-view-attr__img--centered EntityPhoto-square-3   evi-image lazy-image ember-view"/>
                              </div>

                            </div>

                          </a>

                        </div>

                        <div className="display-flex flex-column align-self-center flex-grow-1">
                          <div className="display-flex flex-row justify-space-between">

                            <a className="optional-action-target-wrapper 
              display-flex flex-column full-width" target="_self"
                               href="https://www.linkedin.com/in/facereplays/add-edit/POSITION/?profileFormEntryPoint=PROFILE_SECTION&amp;entityUrn=urn%3Ali%3Afsd_profilePosition%3A%28ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE%2C2151303327%29&amp;trackingId=KVfkD0pqQrmxQHAfY7eVmg%3D%3D&amp;desktopBackground=PROFILE_DETAIL_SCREEN">
                              <div className="display-flex flex-wrap align-items-center full-height">

                                <div className="display-flex ">

                                  <div className="
          display-flex full-width">

                                    <div className="display-flex align-items-center
              mr1 hoverable-link-text t-bold">
                                      <span aria-hidden="true">Founder</span><span
                                        className="visually-hidden">Founder</span>
                                    </div>
                                   
                                  </div>

                                </div>

                                           </div>
                              <span className="t-14 t-normal">
                  <span aria-hidden="true">Esketchos · Part-time</span><span className="visually-hidden">Esketchos · Part-time</span>
                </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span className="pvs-entity__caption-wrapper"
                      aria-hidden="true">Mar 2023 - Present · 3 yrs 2 mos</span><span
                                  className="visually-hidden">Mar 2023 to Present · 3 yrs 2 mos</span>
              </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span aria-hidden="true">Remote</span><span
                                  className="visually-hidden">Remote</span>
              </span>
                            </a>

                          </div>

                          <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY pvs-entity__sub-components">
                           
                            <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true">Founder &amp; Lead Developer of Esketchos<br/>Conceptualized, designed, and built Esketchos, an interactive EdTech platform from the ground up, created to teach users fundamental drawing skills through a hands-on, web-based application.</span><span
                                              className="visually-hidden">Founder &amp; Lead Developer of Esketchos
Conceptualized, designed, and built Esketchos, an interactive EdTech platform from the ground up, created to teach users fundamental drawing skills through a hands-on, web-based application.</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true"><strong>Skills:</strong><span
                                                className="white-space-pre"> </span>Front-End Development · English · Social Media Marketing · Responsive Web Design · Design · User Experience Design (UED) · Search Engine Optimization (SEO) · User Experience (UX) · React.js</span><span
                                              className="visually-hidden"><strong>Skills:</strong><span
                                              className="white-space-pre"> </span>Front-End Development · English · Social Media Marketing · Responsive Web Design · Design · User Experience Design (UED) · Search Engine Optimization (SEO) · User Experience (UX) · React.js</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                            </ul>
                               </div>

                        </div>
                       

                      </div>


                    </div>

                  </li>
                  <li className="pvs-list__paged-list-item artdeco-list__item pvs-list__item--line-separated pvs-list__item--one-column"
                      id="profilePagedListComponent-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-EXPERIENCE-VIEW-DETAILS-profile-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-NONE-en-US-2">
                    <div>


                     
                      <div className="HeuPqLcJMVEBjxzlrwqBUcusWgcyzaCs
        KgUCFrDhnFecSkQSZkbikfdnXTGbJqxo UmammeebeSSIxbEFumhBTlnCJKUCqsgeIcMKZc
        
        
        
        " data-view-name="profile-component-entity">
                        <div>

                          <a className="optional-action-target-wrapper 
            
            pvs-entity__image-container--outline-offset
            display-flex" target="_self" tabIndex="-1"
                             href="https://www.linkedin.com/search/results/all/?keywords=Self-employed">

                            <div className="ivm-image-view-model  pvs-entity__image ">

                              <div className="ivm-view-attr__img-wrapper
        
        ">
                               
                                <div className="EntityPhoto-square-3-ghost-company ivm-view-attr__ghost-entity  ">
                                  <div className="visually-hidden">Web Developer</div>
                                </div>
                              </div>

                            </div>

                          </a>

                        </div>

                        <div className="display-flex flex-column align-self-center flex-grow-1">
                          <div className="display-flex flex-row justify-space-between">

                            <a className="optional-action-target-wrapper 
              display-flex flex-column full-width" target="_self"
                               href="https://www.linkedin.com/in/facereplays/add-edit/POSITION/?profileFormEntryPoint=PROFILE_SECTION&amp;entityUrn=urn%3Ali%3Afsd_profilePosition%3A%28ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE%2C1885115872%29&amp;trackingId=hm%2Bg3izvSEGQ0%2FMt%2BGpU%2BA%3D%3D&amp;desktopBackground=PROFILE_DETAIL_SCREEN">
                              <div className="display-flex flex-wrap align-items-center full-height">

                                <div className="display-flex ">

                                  <div className="
          display-flex full-width">

                                    <div className="display-flex align-items-center
              mr1 hoverable-link-text t-bold">
                                      <span aria-hidden="true">Web Developer</span><span
                                        className="visually-hidden">Web Developer</span>
                                    </div>
                                   
                                  </div>

                                </div>

                                           </div>
                              <span className="t-14 t-normal">
                  <span aria-hidden="true">Self-employed</span><span
                                  className="visually-hidden">Self-employed</span>
                </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span className="pvs-entity__caption-wrapper" aria-hidden="true">Jan 2001 - Present · 25 yrs 4 mos</span><span
                                  className="visually-hidden">Jan 2001 to Present · 25 yrs 4 mos</span>
              </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span aria-hidden="true">Valencia, Valencian Community, Spain · Hybrid</span><span
                                  className="visually-hidden">Valencia, Valencian Community, Spain · Hybrid</span>
              </span>
                            </a>

                          </div>

                          <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY pvs-entity__sub-components">
                           
                            <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true">Developed bespoke websites for local businesses and artists, managing the entire project lifecycle from concept to launch.<br/>Project: dibujoconmodelovalencia.com - Live Model Drawing Event Platform<br/>Engineered a complete web solution for a local art event organizer.<br/>The platform features an event calendar, a dynamic gallery for showcasing artwork, and an integrated booking/ticketing system.<br/>Built a custom administrative dashboard allowing the client to easily manage event schedules, update content, and track attendance.<br/>Project: barbarapalmertangovalencia.com - Tango School &amp; Event Portal<br/>Developed a professional online presence for a tango instructor and community organizer.<br/>The site includes class schedules, instructor biographies, a photo/video gallery, and clear calls-to-action for class registration.<br/>Focused on creating an elegant and intuitive user interface that reflects the brand's aesthetic while providing seamless navigation for students.</span><span
                                              className="visually-hidden">Developed bespoke websites for local businesses and artists, managing the entire project lifecycle from concept to launch.
Project: dibujoconmodelovalencia.com - Live Model Drawing Event Platform
Engineered a complete web solution for a local art event organizer.
The platform features an event calendar, a dynamic gallery for showcasing artwork, and an integrated booking/ticketing system.
Built a custom administrative dashboard allowing the client to easily manage event schedules, update content, and track attendance.
Project: barbarapalmertangovalencia.com - Tango School &amp; Event Portal
Developed a professional online presence for a tango instructor and community organizer.
The site includes class schedules, instructor biographies, a photo/video gallery, and clear calls-to-action for class registration.
Focused on creating an elegant and intuitive user interface that reflects the brand's aesthetic while providing seamless navigation for students.</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true"><strong>Skills:</strong><span
                                                className="white-space-pre"> </span>Angular · Branding &amp; Identity · Web Applications · Node.js · Heroku · PHP · Front-End Development · English · TypeScript · JavaScript · Three.js · Databases · Social Media Marketing · SQL · Logo Design · Responsive Web Design · Design · Cascading Style Sheets (CSS) · AngularJS · User Experience Design (UED) · Search Engine Optimization (SEO) · Vue.js · User Experience (UX) · User Interface Design · Git · HTML5 · REST APIs</span><span
                                              className="visually-hidden"><strong>Skills:</strong><span
                                              className="white-space-pre"> </span>Angular · Branding &amp; Identity · Web Applications · Node.js · Heroku · PHP · Front-End Development · English · TypeScript · JavaScript · Three.js · Databases · Social Media Marketing · SQL · Logo Design · Responsive Web Design · Design · Cascading Style Sheets (CSS) · AngularJS · User Experience Design (UED) · Search Engine Optimization (SEO) · Vue.js · User Experience (UX) · User Interface Design · Git · HTML5 · REST APIs</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <a className="optional-action-target-wrapper" target="_self"
                                         href="https://www.linkedin.com/in/facereplays/details/experience/1635510716212/single-media-viewer?type=IMAGE&amp;profileId=ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE">
                                        <div className="display-flex flex-row">
                                          <div>


                                            <div className="pvs-thumbnail__wrapper"
                                                 aria-label="Thumbnail for Live drawing of model">

                                              <figure className="pvs-thumbnail">
                                                <img
                                                    src="https://media.licdn.com/dms/image/v2/C4D2DAQEPcTmLVzQVPw/profile-treasury-image-shrink_160_160/profile-treasury-image-shrink_160_160/0/1670674596989?e=1776920400&amp;v=beta&amp;t=wPVZr7SQx2f0kw0YAae1voX9zJxAqGQP4Y8e7GP9m08"
                                                    loading="lazy" alt="" id="thumbnail-image-ember539"
                                                    className="pvs-thumbnail__image evi-image lazy-image ember-view"/>
                                               
                                                     </figure>

                                            </div>


                                          </div>

                                          <div className="flex-column ml1 align-self-center">

                                            <div className="StoRTkGEJNSzlgVIovRSBOOMtQTbDaafw
        inline-show-more-text--is-collapsed
        inline-show-more-text--is-collapsed-with-line-clamp
        
        
        
         t-14 t-bold break-words"  dir="ltr" tabIndex="-1">

                                              <span aria-hidden="true">Live drawing of model</span><span
                                                className="visually-hidden">Live drawing of model</span>

                                                 </div>


                                            <div className="display-flex ">

                                              <div className="
          display-flex full-width">


                                                <div className="dikfMnxTTeFxVopxPtkdyyjYCzgucQZx
          full-width t-14 t-normal t-black display-flex align-items-center" dir="ltr">

                                                  <div className="StoRTkGEJNSzlgVIovRSBOOMtQTbDaafw
        inline-show-more-text--is-collapsed
        inline-show-more-text--is-collapsed-with-line-clamp
        
        
        
         full-width"  dir="ltr" tabIndex="-1">

                                                    <span aria-hidden="true">Example of touchscreen drawing on app created in NodeJs and Angular<br/><br/>https://www.facereplays.com/tablet/330</span><span
                                                      className="visually-hidden">Example of touchscreen drawing on app created in NodeJs and Angular

https://www.facereplays.com/tablet/330</span>

                                                   
                                                       </div>

                                                </div>

                                               
                                              </div>

                                            </div>

                                          </div>
                                        </div>
                                      </a>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                            </ul>
                               </div>

                        </div>
                       

                      </div>


                    </div>

                  </li>
                  <li className="pvs-list__paged-list-item artdeco-list__item pvs-list__item--line-separated pvs-list__item--one-column"
                      id="profilePagedListComponent-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-EXPERIENCE-VIEW-DETAILS-profile-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-NONE-en-US-3">
                    <div>


                     
                      <div className="HeuPqLcJMVEBjxzlrwqBUcusWgcyzaCs
        KgUCFrDhnFecSkQSZkbikfdnXTGbJqxo UmammeebeSSIxbEFumhBTlnCJKUCqsgeIcMKZc
        
        
        
        " data-view-name="profile-component-entity">
                        <div>

                          <a className="optional-action-target-wrapper 
            
            pvs-entity__image-container--outline-offset
            display-flex" target="_self" href="https://www.linkedin.com/company/695969/">

                            <div className="ivm-image-view-model  pvs-entity__image ">

                              <div className="ivm-view-attr__img-wrapper
        
        ">
                               
                                <img width="48"
                                             src="https://media.licdn.com/dms/image/v2/C4D0BAQHSbVoJGTuWhg/company-logo_100_100/company-logo_100_100/0/1670686485860?e=1778112000&amp;v=beta&amp;t=o4vdHHKo6gYSc0rBsTQewyc_PK1O3CRMCEbC_lwf7OU"
                                             loading="lazy" height="48" alt="Talenco Promopartner logo" id="ember545"
                                             className="ivm-view-attr__img--centered EntityPhoto-square-3   evi-image lazy-image ember-view"/>
                              </div>

                            </div>

                          </a>

                        </div>

                        <div className="display-flex flex-column align-self-center flex-grow-1">
                          <div className="display-flex flex-row justify-space-between">

                            <a className="optional-action-target-wrapper 
              display-flex flex-column full-width" target="_self"
                               href="https://www.linkedin.com/in/facereplays/add-edit/POSITION/?profileFormEntryPoint=PROFILE_SECTION&amp;entityUrn=urn%3Ali%3Afsd_profilePosition%3A%28ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE%2C1885118815%29&amp;trackingId=SvGnvaBsRpmTHRjhuPyZkQ%3D%3D&amp;desktopBackground=PROFILE_DETAIL_SCREEN">
                              <div className="display-flex flex-wrap align-items-center full-height">

                                <div className="display-flex ">

                                  <div className="
          display-flex full-width">

                                    <div className="display-flex align-items-center
              mr1 hoverable-link-text t-bold">
                                      <span aria-hidden="true">Full-stack Developer</span><span
                                        className="visually-hidden">Full-stack Developer</span>
                                    </div>
                                   
                                  </div>

                                </div>

                                           </div>
                              <span className="t-14 t-normal">
                  <span aria-hidden="true">Talenco Promopartner · Contract</span><span
                                  className="visually-hidden">Talenco Promopartner · Contract</span>
                </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span className="pvs-entity__caption-wrapper" aria-hidden="true">Jan 2005 - Present · 21 yrs 4 mos</span><span
                                  className="visually-hidden">Jan 2005 to Present · 21 yrs 4 mos</span>
              </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span aria-hidden="true">Helsinki Metropolitan Area</span><span
                                  className="visually-hidden">Helsinki Metropolitan Area</span>
              </span>
                            </a>

                          </div>

                          <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY pvs-entity__sub-components">
                           
                            <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true">Project: Talenco B2B Corporate Gifting Platform<br/>Architected a multi-tenant e-commerce engine to provide individual, branded "sub-shops" for each of Talenco's corporate clients.<br/>Empowered users with advanced ordering capabilities, including placing bulk orders for business gifts, designating unique recipients for each item, and tracking order status.<br/>Developed a robust reporting module for clients to monitor their shop's activity, manage budgets, and analyze spending.<br/>Engineered seamless, real-time integrations with Talenco’s primary database, multiple inventory management systems, and various postal/logistics APIs to automate the entire fulfillment process.</span><span
                                              className="visually-hidden">Project: Talenco B2B Corporate Gifting Platform
Architected a multi-tenant e-commerce engine to provide individual, branded "sub-shops" for each of Talenco's corporate clients.
Empowered users with advanced ordering capabilities, including placing bulk orders for business gifts, designating unique recipients for each item, and tracking order status.
Developed a robust reporting module for clients to monitor their shop's activity, manage budgets, and analyze spending.
Engineered seamless, real-time integrations with Talenco’s primary database, multiple inventory management systems, and various postal/logistics APIs to automate the entire fulfillment process.</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true"><strong>Skills:</strong><span
                                                className="white-space-pre"> </span>Branding &amp; Identity · Node.js · PHP · Front-End Development · English · TypeScript · JavaScript · Social Media Marketing · GraphQL · Responsive Web Design · E-Commerce · Design · Cascading Style Sheets (CSS) · User Experience Design (UED) · Search Engine Optimization (SEO) · Laravel · User Experience (UX) · Illustrator · User Interface Design · Adobe InDesign · HTML5 · REST APIs</span><span
                                              className="visually-hidden"><strong>Skills:</strong><span
                                              className="white-space-pre"> </span>Branding &amp; Identity · Node.js · PHP · Front-End Development · English · TypeScript · JavaScript · Social Media Marketing · GraphQL · Responsive Web Design · E-Commerce · Design · Cascading Style Sheets (CSS) · User Experience Design (UED) · Search Engine Optimization (SEO) · Laravel · User Experience (UX) · Illustrator · User Interface Design · Adobe InDesign · HTML5 · REST APIs</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <a className="optional-action-target-wrapper" target="_self"
                                         href="https://www.linkedin.com/in/facereplays/details/experience/1635477512754/single-media-viewer?type=DOCUMENT&amp;profileId=ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE">
                                        <div className="display-flex flex-row">
                                          <div>


                                            <div className="pvs-thumbnail__wrapper"
                                                 aria-label="Thumbnail for HandDrawings.pdf">

                                              <figure className="pvs-thumbnail">
                                                <img
                                                    src="https://media.licdn.com/dms/image/v2/C4E2DAQG47QXjP9KpoQ/profile-treasury-document-cover-images_480/profile-treasury-document-cover-images_480/0/1639597561875?e=1776920400&amp;v=beta&amp;t=nmKcXzQNgbgQhyMqF8AXL29KC__jpfrUqfMpglkTq1c"
                                                    loading="lazy" alt="" id="thumbnail-image-ember551"
                                                    className="pvs-thumbnail__image evi-image lazy-image ember-view"/>
                                               
                                                     </figure>

                                            </div>


                                          </div>

                                          <div className="flex-column ml1 align-self-center">

                                            <div className="StoRTkGEJNSzlgVIovRSBOOMtQTbDaafw
        inline-show-more-text--is-collapsed
        inline-show-more-text--is-collapsed-with-line-clamp
        
        
        
         t-14 t-bold break-words"  dir="ltr" tabIndex="-1">

                                              <span aria-hidden="true">HandDrawings.pdf</span><span
                                                className="visually-hidden">HandDrawings.pdf</span>

                                                 </div>


                                                   </div>
                                        </div>
                                      </a>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                            </ul>
                               </div>

                        </div>
                       

                      </div>


                    </div>

                  </li>
                  <li className="pvs-list__paged-list-item artdeco-list__item pvs-list__item--line-separated pvs-list__item--one-column"
                      id="profilePagedListComponent-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-EXPERIENCE-VIEW-DETAILS-profile-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-NONE-en-US-4">
                    <div>


                     
                      <div className="HeuPqLcJMVEBjxzlrwqBUcusWgcyzaCs
        KgUCFrDhnFecSkQSZkbikfdnXTGbJqxo UmammeebeSSIxbEFumhBTlnCJKUCqsgeIcMKZc
        
        
        
        " data-view-name="profile-component-entity">
                        <div>

                          <a className="optional-action-target-wrapper 
            
            pvs-entity__image-container--outline-offset
            display-flex" target="_self" tabIndex="-1"
                             href="https://www.linkedin.com/search/results/all/?keywords=AMCongress">

                            <div className="ivm-image-view-model  pvs-entity__image ">

                              <div className="ivm-view-attr__img-wrapper
        
        ">
                               
                                <div className="EntityPhoto-square-3-ghost-company ivm-view-attr__ghost-entity  ">
                                  <div className="visually-hidden">Director of IT, Teamlead</div>
                                </div>
                              </div>

                            </div>

                          </a>

                        </div>

                        <div className="display-flex flex-column align-self-center flex-grow-1">
                          <div className="display-flex flex-row justify-space-between">

                            <a className="optional-action-target-wrapper 
              display-flex flex-column full-width" target="_self"
                               href="https://www.linkedin.com/in/facereplays/add-edit/POSITION/?profileFormEntryPoint=PROFILE_SECTION&amp;entityUrn=urn%3Ali%3Afsd_profilePosition%3A%28ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE%2C1885115954%29&amp;trackingId=rxwN8xkmQL6kWVcVUHqqjg%3D%3D&amp;desktopBackground=PROFILE_DETAIL_SCREEN">
                              <div className="display-flex flex-wrap align-items-center full-height">

                                <div className="display-flex ">

                                  <div className="
          display-flex full-width">

                                    <div className="display-flex align-items-center
              mr1 hoverable-link-text t-bold">
                                      <span aria-hidden="true">Director of IT, Teamlead</span><span
                                        className="visually-hidden">Director of IT, Teamlead</span>
                                    </div>
                                   
                                  </div>

                                </div>

                                           </div>
                              <span className="t-14 t-normal">
                  <span aria-hidden="true">AMCongress · Contract</span><span className="visually-hidden">AMCongress · Contract</span>
                </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span className="pvs-entity__caption-wrapper" aria-hidden="true">Apr 2006 - Jan 2023 · 16 yrs 10 mos</span><span
                                  className="visually-hidden">Apr 2006 to Jan 2023 · 16 yrs 10 mos</span>
              </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span aria-hidden="true">Moscow, Moscow City, Russia</span><span
                                  className="visually-hidden">Moscow, Moscow City, Russia</span>
              </span>
                            </a>

                          </div>

                          <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY pvs-entity__sub-components">
                           
                            <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true">I architected and developed a comprehensive platform designed to serve distinct professional audiences across multiple domains. The core challenge was to create a scalable, maintainable, and cost-effective solution for launching and managing a family of related websites.<br/>My solution was a unified architecture:<br/>A single, powerful back-end template serves as the foundation for all sites.<br/>A centralized workspace allows for streamlined administration, content updates, and user management across the entire network.<br/>The results were significant:<br/>Performance: The platform proved its stability by handling over 8,000 daily visits.<br/>Revenue Generation: An integrated payment system successfully processed up to 150 daily transactions for paid subscriptions.<br/>Operational Efficiency: The client can now launch new portals rapidly without rebuilding from scratch.<br/>This platform powers live sites such as educationmanagers.ru, hospitalmanagers.ru, and preschools.ru.</span><span
                                              className="visually-hidden">I architected and developed a comprehensive platform designed to serve distinct professional audiences across multiple domains. The core challenge was to create a scalable, maintainable, and cost-effective solution for launching and managing a family of related websites.
My solution was a unified architecture:
A single, powerful back-end template serves as the foundation for all sites.
A centralized workspace allows for streamlined administration, content updates, and user management across the entire network.
The results were significant:
Performance: The platform proved its stability by handling over 8,000 daily visits.
Revenue Generation: An integrated payment system successfully processed up to 150 daily transactions for paid subscriptions.
Operational Efficiency: The client can now launch new portals rapidly without rebuilding from scratch.
This platform powers live sites such as educationmanagers.ru, hospitalmanagers.ru, and preschools.ru.</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true"><strong>Skills:</strong><span
                                                className="white-space-pre"> </span>PHP · Front-End Development · English · JavaScript · Social Media Marketing · Logo Design · GraphQL · Responsive Web Design · E-Commerce · Design · Corporate Identity · User Experience Design (UED) · Search Engine Optimization (SEO) · Vue.js · User Experience (UX) · Illustrator · React.js · User Interface Design · REST APIs</span><span
                                              className="visually-hidden"><strong>Skills:</strong><span
                                              className="white-space-pre"> </span>PHP · Front-End Development · English · JavaScript · Social Media Marketing · Logo Design · GraphQL · Responsive Web Design · E-Commerce · Design · Corporate Identity · User Experience Design (UED) · Search Engine Optimization (SEO) · Vue.js · User Experience (UX) · Illustrator · React.js · User Interface Design · REST APIs</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <a className="optional-action-target-wrapper" target="_self"
                                         href="https://www.linkedin.com/in/facereplays/details/experience/1635510712858/single-media-viewer?type=IMAGE&amp;profileId=ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE">
                                        <div className="display-flex flex-row">
                                          <div>


                                            <div className="pvs-thumbnail__wrapper"
                                                 aria-label="Thumbnail for traffic as of year 2022">

                                              <figure className="pvs-thumbnail">
                                                <img
                                                    src="https://media.licdn.com/dms/image/v2/C4D2DAQFfEmXUtuYnSg/profile-treasury-image-shrink_160_160/profile-treasury-image-shrink_160_160/0/1670674520593?e=1776920400&amp;v=beta&amp;t=y3yRlpZ-sdUyMKO97j-ONcGdItG6rMEsEw0gNpcd7t4"
                                                    loading="lazy" alt="" id="thumbnail-image-ember561"
                                                    className="pvs-thumbnail__image evi-image lazy-image ember-view"/>
                                               
                                                     </figure>

                                            </div>


                                          </div>

                                          <div className="flex-column ml1 align-self-center">

                                            <div className="StoRTkGEJNSzlgVIovRSBOOMtQTbDaafw
        inline-show-more-text--is-collapsed
        inline-show-more-text--is-collapsed-with-line-clamp
        
        
        
         t-14 t-bold break-words"  dir="ltr" tabIndex="-1">

                                              <span aria-hidden="true">traffic as of year 2022</span><span
                                                className="visually-hidden">traffic as of year 2022</span>

                                                 </div>


                                            <div className="display-flex ">

                                              <div className="
          display-flex full-width">


                                                <div className="dikfMnxTTeFxVopxPtkdyyjYCzgucQZx
          full-width t-14 t-normal t-black display-flex align-items-center" dir="ltr">

                                                  <div className="StoRTkGEJNSzlgVIovRSBOOMtQTbDaafw
        inline-show-more-text--is-collapsed
        inline-show-more-text--is-collapsed-with-line-clamp
        
        
        
         full-width"  dir="ltr" tabIndex="-1">

                                                    <span
                                                        aria-hidden="true">Screenshot of traffic</span><span
                                                      className="visually-hidden">Screenshot of traffic</span>

                                                       </div>

                                                </div>

                                               
                                              </div>

                                            </div>

                                          </div>
                                        </div>
                                      </a>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                            </ul>
                               </div>

                        </div>
                       

                      </div>


                    </div>

                  </li>
                  <li className="pvs-list__paged-list-item artdeco-list__item pvs-list__item--line-separated pvs-list__item--one-column"
                      id="profilePagedListComponent-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-EXPERIENCE-VIEW-DETAILS-profile-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-NONE-en-US-5">
                    <div>


                     
                      <div className="HeuPqLcJMVEBjxzlrwqBUcusWgcyzaCs
        KgUCFrDhnFecSkQSZkbikfdnXTGbJqxo UmammeebeSSIxbEFumhBTlnCJKUCqsgeIcMKZc
        
        
        
        " data-view-name="profile-component-entity">
                        <div>

                          <a className="optional-action-target-wrapper 
            
            pvs-entity__image-container--outline-offset
            display-flex" target="_self" tabIndex="-1"
                             href="https://www.linkedin.com/search/results/all/?keywords=Self-employed">

                            <div className="ivm-image-view-model  pvs-entity__image ">

                              <div className="ivm-view-attr__img-wrapper
        
        ">
                               
                                <div className="EntityPhoto-square-3-ghost-company ivm-view-attr__ghost-entity  ">
                                  <div className="visually-hidden">Freelance Graphic Designer</div>
                                </div>
                              </div>

                            </div>

                          </a>

                        </div>

                        <div className="display-flex flex-column align-self-center flex-grow-1">
                          <div className="display-flex flex-row justify-space-between">

                            <a className="optional-action-target-wrapper 
              display-flex flex-column full-width" target="_self"
                               href="https://www.linkedin.com/in/facereplays/add-edit/POSITION/?profileFormEntryPoint=PROFILE_SECTION&amp;entityUrn=urn%3Ali%3Afsd_profilePosition%3A%28ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE%2C2154124860%29&amp;trackingId=mdCPbc5aT3KvYQiiorsWjg%3D%3D&amp;desktopBackground=PROFILE_DETAIL_SCREEN">
                              <div className="display-flex flex-wrap align-items-center full-height">

                                <div className="display-flex ">

                                  <div className="
          display-flex full-width">

                                    <div className="display-flex align-items-center
              mr1 hoverable-link-text t-bold">
                                      <span aria-hidden="true">Freelance Graphic Designer</span><span
                                        className="visually-hidden">Freelance Graphic Designer</span>
                                    </div>
                                   
                                  </div>

                                </div>

                                           </div>
                              <span className="t-14 t-normal">
                  <span aria-hidden="true">Self-employed</span><span
                                  className="visually-hidden">Self-employed</span>
                </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span className="pvs-entity__caption-wrapper" aria-hidden="true">Sep 1991 - May 2004 · 12 yrs 9 mos</span><span
                                  className="visually-hidden">Sep 1991 to May 2004 · 12 yrs 9 mos</span>
              </span>
                                       </a>

                          </div>

                          <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY pvs-entity__sub-components">
                           
                            <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true">Corporate design, illustration, desktop publishing</span><span
                                              className="visually-hidden">Corporate design, illustration, desktop publishing</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true"><strong>Skills:</strong><span
                                                className="white-space-pre"> </span>English · Responsive Web Design · Design · Corporate Identity · Typography</span><span
                                              className="visually-hidden"><strong>Skills:</strong><span
                                              className="white-space-pre"> </span>English · Responsive Web Design · Design · Corporate Identity · Typography</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                            </ul>
                               </div>

                        </div>
                       

                      </div>


                    </div>

                  </li>
                  <li className="pvs-list__paged-list-item artdeco-list__item pvs-list__item--line-separated pvs-list__item--one-column"
                      id="profilePagedListComponent-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-EXPERIENCE-VIEW-DETAILS-profile-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-NONE-en-US-6">
                    <div>


                     
                      <div className="HeuPqLcJMVEBjxzlrwqBUcusWgcyzaCs
        KgUCFrDhnFecSkQSZkbikfdnXTGbJqxo UmammeebeSSIxbEFumhBTlnCJKUCqsgeIcMKZc
        
        
        
        " data-view-name="profile-component-entity">
                        <div>

                          <a className="optional-action-target-wrapper 
            
            pvs-entity__image-container--outline-offset
            display-flex" target="_self" href="https://www.linkedin.com/company/166588/">

                            <div className="ivm-image-view-model  pvs-entity__image ">

                              <div className="ivm-view-attr__img-wrapper
        
        ">
                               
                                <img width="48"
                                             src="https://media.licdn.com/dms/image/v2/C4E0BAQFyFocnRHcJ1Q/company-logo_100_100/company-logo_100_100/0/1676888912522/unesco_logo?e=1778112000&amp;v=beta&amp;t=uufDGAjAhnu8X5iRZ1cTCwXLExICgsRKxsYGBozvgP0"
                                             loading="lazy" height="48" alt="UNESCO logo" id="ember573"
                                             className="ivm-view-attr__img--centered EntityPhoto-square-3   evi-image lazy-image ember-view"/>
                              </div>

                            </div>

                          </a>

                        </div>

                        <div className="display-flex flex-column align-self-center flex-grow-1">
                          <div className="display-flex flex-row justify-space-between">

                            <a className="optional-action-target-wrapper 
              display-flex flex-column full-width" target="_self"
                               href="https://www.linkedin.com/in/facereplays/add-edit/POSITION/?profileFormEntryPoint=PROFILE_SECTION&amp;entityUrn=urn%3Ali%3Afsd_profilePosition%3A%28ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE%2C1864216541%29&amp;trackingId=EPwbVhP3QLGbbkPhzXtWHg%3D%3D&amp;desktopBackground=PROFILE_DETAIL_SCREEN">
                              <div className="display-flex flex-wrap align-items-center full-height">

                                <div className="display-flex ">

                                  <div className="
          display-flex full-width">

                                    <div className="display-flex align-items-center
              mr1 hoverable-link-text t-bold">
                                      <span aria-hidden="true">Graphic Designer</span><span
                                        className="visually-hidden">Graphic Designer</span>
                                    </div>
                                   
                                  </div>

                                </div>

                                           </div>
                              <span className="t-14 t-normal">
                  <span aria-hidden="true">UNESCO · Contract</span><span className="visually-hidden">UNESCO · Contract</span>
                </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span className="pvs-entity__caption-wrapper"
                      aria-hidden="true">Jan 2003 - Jan 2004 · 1 yr 1 mo</span><span
                                  className="visually-hidden">Jan 2003 to Jan 2004 · 1 yr 1 mo</span>
              </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span aria-hidden="true">Paris, Île-de-France, France</span><span
                                  className="visually-hidden">Paris, Île-de-France, France</span>
              </span>
                            </a>

                          </div>

                          <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY pvs-entity__sub-components">
                           
                            <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span
                                                aria-hidden="true">Graphic Design &amp; Illustration for UNESCO &amp; ILO<br/>Designed a range of visual materials, including layouts and posters, for international organizations such as UNESCO and the International Labour Organization (ILO).<br/>Received a formal Letter of Gratitude from UNESCO in recognition of my high-quality illustration and layout design for their official publication, the "Media Relations" handbook.<br/><br/>https://webarchive.unesco.org/web/20160116005524/http://portal.unesco.org/en/files/16819/10666628213Media-guide_maq.pdf/Media-guide_maq.pdf</span><span
                                              className="visually-hidden">Graphic Design &amp; Illustration for UNESCO &amp; ILO
Designed a range of visual materials, including layouts and posters, for international organizations such as UNESCO and the International Labour Organization (ILO).
Received a formal Letter of Gratitude from UNESCO in recognition of my high-quality illustration and layout design for their official publication, the "Media Relations" handbook.

https://webarchive.unesco.org/web/20160116005524/http://portal.unesco.org/en/files/16819/10666628213Media-guide_maq.pdf/Media-guide_maq.pdf</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true"><strong>Skills:</strong><span
                                                className="white-space-pre"> </span>Branding &amp; Identity · English · Design · Adobe Photoshop · Corporate Identity · Illustrator · Adobe InDesign</span><span
                                              className="visually-hidden"><strong>Skills:</strong><span
                                              className="white-space-pre"> </span>Branding &amp; Identity · English · Design · Adobe Photoshop · Corporate Identity · Illustrator · Adobe InDesign</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <a className="optional-action-target-wrapper" target="_self"
                                         href="https://www.linkedin.com/in/facereplays/details/experience/1635473324594/single-media-viewer?type=DOCUMENT&amp;profileId=ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE">
                                        <div className="display-flex flex-row">
                                          <div>


                                            <div className="pvs-thumbnail__wrapper"
                                                 aria-label="Thumbnail for DOCUMENT.pdf">

                                              <figure className="pvs-thumbnail">
                                                <img
                                                    src="https://media.licdn.com/dms/image/v2/C562DAQGSJLwgFO8rfA/profile-treasury-document-cover-images_480/profile-treasury-document-cover-images_480/0/1635784698600?e=1776920400&amp;v=beta&amp;t=uSf59_TO3pEWMHWdCI_dlbRJ7f7k9_N6f2J1zoLsoWE"
                                                    loading="lazy" alt="" id="thumbnail-image-ember579"
                                                    className="pvs-thumbnail__image evi-image lazy-image ember-view"/>
                                               
                                                     </figure>

                                            </div>


                                          </div>

                                          <div className="flex-column ml1 align-self-center">

                                            <div className="StoRTkGEJNSzlgVIovRSBOOMtQTbDaafw
        inline-show-more-text--is-collapsed
        inline-show-more-text--is-collapsed-with-line-clamp
        
        
        
         t-14 t-bold break-words"  dir="ltr" tabIndex="-1">

                                              <span aria-hidden="true">DOCUMENT.pdf</span><span
                                                className="visually-hidden">DOCUMENT.pdf</span>

                                                 </div>


                                                   </div>
                                        </div>
                                      </a>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                            </ul>
                               </div>

                        </div>

                      </div>


                    </div>

                  </li>
                  <li className="pvs-list__paged-list-item artdeco-list__item pvs-list__item--line-separated pvs-list__item--one-column"
                      id="profilePagedListComponent-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-EXPERIENCE-VIEW-DETAILS-profile-ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE-NONE-en-US-7">
                    <div>


                     
                      <div className="HeuPqLcJMVEBjxzlrwqBUcusWgcyzaCs
        KgUCFrDhnFecSkQSZkbikfdnXTGbJqxo UmammeebeSSIxbEFumhBTlnCJKUCqsgeIcMKZc
        
        
        
        " data-view-name="profile-component-entity">
                        <div>

                          <a className="optional-action-target-wrapper 
            
            pvs-entity__image-container--outline-offset
            display-flex" target="_self" tabIndex="-1"
                             href="https://www.linkedin.com/search/results/all/?keywords=Fishkey+Advertising+Agency">

                            <div className="ivm-image-view-model  pvs-entity__image ">

                              <div className="ivm-view-attr__img-wrapper
        
        ">
                               
                                <div className="EntityPhoto-square-3-ghost-company ivm-view-attr__ghost-entity  ">
                                  <div className="visually-hidden">art director</div>
                                </div>
                              </div>

                            </div>

                          </a>

                        </div>

                        <div className="display-flex flex-column align-self-center flex-grow-1">
                          <div className="display-flex flex-row justify-space-between">

                            <a className="optional-action-target-wrapper 
              display-flex flex-column full-width" target="_self"
                               href="https://www.linkedin.com/in/facereplays/add-edit/POSITION/?profileFormEntryPoint=PROFILE_SECTION&amp;entityUrn=urn%3Ali%3Afsd_profilePosition%3A%28ACoAAAqtz4QBPP7EIRdnsZETvk7li6F6YhatxDE%2C418816382%29&amp;trackingId=3Z9R3IYhTh%2BhUTrWkWLavA%3D%3D&amp;desktopBackground=PROFILE_DETAIL_SCREEN">
                              <div className="display-flex flex-wrap align-items-center full-height">

                                <div className="display-flex ">

                                  <div className="
          display-flex full-width">

                                    <div className="display-flex align-items-center
              mr1 hoverable-link-text t-bold">
                                      <span aria-hidden="true">art director</span><span
                                        className="visually-hidden">art director</span>
                                    </div>
                                   
                                  </div>

                                </div>

                                           </div>
                              <span className="t-14 t-normal">
                  <span aria-hidden="true">Fishkey Advertising Agency</span><span
                                  className="visually-hidden">Fishkey Advertising Agency</span>
                </span>
                              <span className="t-14 t-normal
                  t-black--light">
                <span className="pvs-entity__caption-wrapper"
                      aria-hidden="true">2000 - 2002 · 2 yrs</span><span className="visually-hidden">2000 to 2002 · 2 yrs</span>
              </span>
                                       </a>

                          </div>

                          <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY pvs-entity__sub-components">
                           
                            <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                              <li className="QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                <div className="JlydBcKUXNFWyNfcBjJHAsVIQyNFTpkVSVnTAY">
                                 
                                  <ul className="VMEtZywGOeUBGxsJnpcYDrsPLZTMJhXzim
            
            
            ">
                                    <li className="pvs-list__item--with-top-padding QnKYTfdpeyavfaRAlKwWLIXRUYOVgvE">


                                      <div className="display-flex ">

                                        <div className="
          display-flex full-width">

                                          <div className="display-flex align-items-center
              t-14 t-normal t-black">
                                            <span aria-hidden="true"><strong>Skills:</strong><span
                                                className="white-space-pre"> </span>Branding &amp; Identity · English · Logo Design · Design · Corporate Identity · Illustrator · Adobe InDesign</span><span
                                              className="visually-hidden"><strong>Skills:</strong><span
                                              className="white-space-pre"> </span>Branding &amp; Identity · English · Logo Design · Design · Corporate Identity · Illustrator · Adobe InDesign</span>
                                          </div>
                                         
                                        </div>

                                      </div>


                                    </li>
                                  </ul>
                                     </div>


                              </li>
                            </ul>
                               </div>

                        </div>
                       

                      </div>


                    </div>

                  </li>
                </ul>

              </div>


             
              <div>

               
              </div>

            </div>
          </div>


        </section>
      </div>
  );
}

export default Cv;
